angular.module("Main").controller("OnlineSalesGebuehrenUndPauschalenController", ["$scope", "$q", "$translate", "$window", "BookingService",
    function ($scope, $q, $translate, $window, BookingService) {
        let vm = this;
        vm.parent = $scope.$parent.vm;
        vm.angebot = vm.parent.angebot;
        vm.layoutColors = vm.parent.layoutColors;
        vm.choosenMembershipIndex = vm.parent.choosenMembershipIndex;
        vm.beginZL = 0;
        vm.limitLengthZL = vm.parent.limitLengthZL;
        vm.onlineSalesConfig = vm.parent.onlineSalesConfig;
        vm.selectedMembership = vm.parent.selectedMembership;
        vm.selectedMembershipId = vm.parent.surveyId;
        vm.hasPauschalenWithPrice = vm.parent.hasPauschalenWithPrice;
        vm.hasGebuehrenWithPrice = vm.parent.hasGebuehrenWithPrice;
        vm.basistarif = vm.parent.basistarif;
        vm.pflichtGebuehren = vm.parent.pflichtGebuehren;
        vm.pflichtGebuehrenOrig = _.uniq(vm.parent.pflichtGebuehrenOrig);
        vm.selectedMembershipGebuehrenToSelect = vm.parent.selectedMembershipGebuehrenToSelect;
        vm.selectedMembershipPauschalenToSelect = vm.parent.selectedMembershipPauschalenToSelect;
        vm.pflichtZusatztarifePreis = vm.parent.pflichtZusatztarifePreis;
        vm.pflichtZusatztarife = vm.parent.pflichtZusatztarife;
        vm.selectedAdditionsGesamt = vm.parent.selectedAdditionsGesamt;
        vm.selectedAdditions = vm.parent.selectedAdditions;
        vm.selectedAdditionsIds = vm.parent.selectedAdditionsIds ? vm.parent.selectedAdditionsIds : [];
        vm.selectedAdditionsPauschalen = vm.parent.selectedAdditionsPauschalen ? vm.parent.selectedAdditionsPauschalen : (vm.parent.SelectedAdditionsPauschalen ? vm.parent.SelectedAdditionsPauschalen : []);
        vm.selectedAdditionsPauschalenIds = vm.parent.selectedAdditionsPauschalenIds ? vm.parent.selectedAdditionsPauschalenIds : [];
        vm.selectedAdditionsGebuehrenIds = vm.parent.selectedAdditionsGebuehrenIds ? vm.parent.selectedAdditionsGebuehrenIds : [];
        vm.selectedAdditionsGebuehren = vm.parent.selectedAdditionsGebuehren ? vm.parent.selectedAdditionsGebuehren : (vm.parent.SelectedAdditionsGebuehren ? vm.parent.SelectedAdditionsGebuehren : []);
        vm.selectedMember = vm.parent.selectedMember;
        vm.memberSelected = vm.parent.memberSelected;
        vm.choosenMemberAngebot = vm.parent.choosenMemberAngebot;
        vm.selectedFoundAngebot = vm.parent.selectedFoundAngebot;
        vm.choosenNewangebotForMember = vm.parent.choosenNewangebotForMember;
        vm.choosenMemberAngebotDatum = vm.parent.choosenMemberAngebotDatum;
        vm.selectedFoundAngebotDatum = vm.parent.selectedFoundAngebotDatum;
        vm.selectedPauschalenWithMembershipZyklus = vm.parent.selectedPauschalenWithMembershipZyklus ? vm.parent.selectedPauschalenWithMembershipZyklus : [];
        vm.selectedPauschalenWithMembershipZyklusIds = vm.parent.selectedPauschalenWithMembershipZyklusIds ? vm.parent.selectedPauschalenWithMembershipZyklusIds : [];

        _.forEach(vm.selectedAdditionsPauschalen, function (s) {
            s.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
            _.find(vm.selectedMembershipPauschalenToSelect, {'Id':s.Id}).BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
        })

        _.forEach(vm.selectedAdditionsGebuehren, function (s) {
            s.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
            _.find(vm.selectedMembershipGebuehrenToSelect, {'Id':s.Id}).BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
        })

        let cycleUnits = BookingService.getCycleUnits();

        getPreise();

        async function getPreise() {
            try {
                await getPflichtPreise()
            } catch (error) {

            }
        }

        function getPflichtPreise() {
            vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.pflichtGebuehrenOrig);
            vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
            _.forEach(vm.pflichtGebuehren, function (g) {
                g.gesamt = _.sumBy(g, 'price');
                g.zahlzyklusName = g[0].zahlzyklus
            });

        }


        if (vm.selectedAdditionsGesamt) {
            vm.summeMitgliedschaft = vm.pflichtZusatztarifePreis ? vm.selectedMembership.Preis + vm.pflichtZusatztarifePreis + vm.selectedAdditionsGesamt :
                vm.selectedMembership.Preis + vm.selectedAdditionsGesamt;
        } else {
            vm.summeMitgliedschaft = vm.pflichtZusatztarifePreis ? vm.selectedMembership.Preis + vm.pflichtZusatztarifePreis :
                vm.selectedMembership.Preis;
        }
        vm.summeMitgliedschaft = vm.pflichtZusatztarifePreis ? vm.selectedMembership.Preis + vm.pflichtZusatztarifePreis + vm.selectedAdditionsGesamt :
            vm.selectedMembership.Preis + vm.selectedAdditionsGesamt;
        vm.locationMembershipBuy = false;
        vm.beginZL = 0;
        var findSurvey = _.find(vm.membershipsOptions, {
            'Mitgliedschaft_Id': vm.selectedMembershipId,
            'Mandant_Id': vm.selectedMandantNr,
            'Laufzeit': vm.selectedMembership.Laufzeit,
            'LaufzeitEinheit':  vm.selectedMembership.Laufzeiteinheit,
            'Zahlzyklus':  vm.selectedMembership.Zahlzyklus,
            'ZahlzyklusEinheit':  vm.selectedMembership.ZahlzyklusEinheit
        });
        if (findSurvey) {
            vm.findSurvey = findSurvey;
            vm.resultZL = findSurvey.Zusatzleistungen_Step_Online;
        }

        if ((vm.findSurvey && vm.resultZL === 0) || (vm.hasPauschalenWithPrice === false &&
                vm.hasGebuehrenWithPrice === false)) {
            vm.index = 5;
            vm.hasZusatzleistungen = false;
            vm.sizeGebuehrenUndPauschalen = _.size(vm.pflichtGebuehren);
            vm.selectedGebuehrenPauschalenGesamt = _.sumBy(vm.pflichtGebuehren, function (o) {
                return o.price;
            });
        } else if ((vm.hasPauschalenWithPrice === true || vm.hasGebuehrenWithPrice === true) && (!vm.findSurvey || (vm.findSurvey && vm.resultZL === 1))) {
            vm.index = 4;
            vm.hasZusatzleistungen = true;
            vm.sizeGebuehrenUndPauschalen = _.size(vm.pflichtGebuehren);
        }

        vm.showMoverZL = (vm.countGebuehrenPrices + vm.countPauschalenPrices) > vm.limitLengthZL;

        vm.concatAdditionsAndExtraWithoutBasistarif = _.concat(vm.selectedAdditions, vm.selectedAdditionsGebuehren, vm.selectedAdditionsPauschalen, vm.pflichtGebuehren);
        vm.concatAdditionsAndExtraAdditions = _.concat(vm.selectedAdditions, vm.selectedAdditionsGebuehren, vm.selectedAdditionsPauschalen, vm.basistarif, vm.pflichtGebuehren);
        vm.concatAdditionsAndExtraAdditions = vm.concatAdditionsAndExtraAdditions.filter(element => {
            return element !== undefined;
        });
        vm.groupedPricesSurveys = _.groupBy(vm.concatAdditionsAndExtraAdditions, 'zahlzyklus');
        _.forEach(vm.groupedPricesSurveys, function (g) {
            g.gesamt = _.sumBy(g, 'price');
            g.zahlzyklusName = g[0].zahlzyklus
        });

        vm.groupedPricesWithoutBasistarif = vm.concatAdditionsAndExtraWithoutBasistarif.filter(element => {
            return element !== undefined;
        });
        
        _.forEach(vm.groupedPricesWithoutBasistarif, function (g) {
            if (!_.isUndefined(g.zahlzyklus))
                g.zahlzyklusName = g.zahlzyklus
        });
        

        vm.checkGebuehren2 = function (gebuehr, price) {
            gebuehr.price = price;
            gebuehr.zahlzyklus = 'einmalig';

            if (!_.includes(vm.selectedAdditionsGebuehrenIds, gebuehr.Id)) {
                vm.selectedAdditionsGebuehrenIds.push(gebuehr.Id);
                vm.selectedAdditionsGebuehren.push(gebuehr);
                gebuehr.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
            } else {
                _.pull(vm.selectedAdditionsGebuehrenIds, gebuehr.Id);
                gebuehr = _.find(vm.selectedAdditionsGebuehren, {Id: gebuehr.Id})
                _.pull(vm.selectedAdditionsGebuehren, gebuehr);
                gebuehr.BorderColor = 'unset';
                _.find(vm.selectedMembershipGebuehrenToSelect, {'Id':gebuehr.Id}).BorderColor = 'unset';
            }
            if (vm.pflichtGebuehrenOrig.length > 0) {
                vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.pflichtGebuehrenOrig);
                vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
                    return element !== undefined;
                });
                vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
                _.forEach(vm.pflichtGebuehren, function (g) {
                    g.zahlzyklusName = g[0].zahlzyklus
                    g.gesamt = _.sumBy(g, 'price');
                });
            } else {
                vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren);
                vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
                    return element !== undefined;
                });
                vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
                _.forEach(vm.pflichtGebuehren, function (g) {
                    g.zahlzyklusName = g[0].zahlzyklus
                    g.gesamt = _.sumBy(g, 'price');
                });
            }

            //vm.selectedGebuehrenPauschalenGesamt = vm.selectedGebuehrenGesamt + vm.selectedPauschalenGesamt;
        };

        vm.checkPauschalen2 = function (pauschale, price, zahlzyklus) {
            pauschale.price = price;
            pauschale.zahlzyklus = pauschale.Zahlzyklus;
            if (pauschale.Zyklus === vm.selectedMembership.Zahlzyklus && pauschale.Zykluseinheit === vm.selectedMembership.ZahlzyklusEinheit) {
                pauschale.price = price;
                pauschale.zahlzyklus = pauschale.Zahlzyklus;
                if (vm.selectedPauschalenWithMembershipZyklus.some(item => item.Id === pauschale.Id)) {
                    pauschale.BorderColor = 'unset';
                    pauschale = _.find(vm.selectedPauschalenWithMembershipZyklus, {Id: pauschale.Id})
                    _.pull(vm.selectedPauschalenWithMembershipZyklus, pauschale);
                } else {
                    pauschale.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
                    pauschale.istPauschale = true;
                    vm.selectedPauschalenWithMembershipZyklus.push(pauschale);
                }
                if (!_.includes(vm.selectedPauschalenWithMembershipZyklusIds, pauschale.Id)) {
                    vm.selectedPauschalenWithMembershipZyklusIds.push(pauschale.Id);
                } else {
                    _.pull(vm.selectedPauschalenWithMembershipZyklusIds, pauschale.Id);
                }
                vm.selectedAdditionsGesamtUndBasistarif = vm.selectedAdditionsGesamt ? (vm.basistarif[0].price + vm.selectedAdditionsGesamt) : vm.basistarif[0].price;
            } else {
                // if (!_.includes(vm.selectedAdditionsPauschalen, pauschale)) {
                //     vm.selectedAdditionsPauschalen.push(pauschale);
                //     pauschale.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
                // } else {
                //     _.pull(vm.selectedAdditionsPauschalen, pauschale);
                //     pauschale.BorderColor = 'unset';
                // }

                if (!_.includes(vm.selectedAdditionsPauschalenIds, pauschale.Id)) {
                    vm.selectedAdditionsPauschalenIds.push(pauschale.Id);
                    vm.selectedAdditionsPauschalen.push(pauschale);
                    pauschale.BorderColor = '5px solid ' + vm.onlineSalesConfig.ItemsGewaehltRahmenFarbe + ' !important';
                } else {
                    pauschale = _.find(vm.selectedAdditionsPauschalen, {Id: pauschale.Id})
                    _.pull(vm.selectedAdditionsPauschalenIds, pauschale.Id);
                    _.pull(vm.selectedAdditionsPauschalen, pauschale);
                    pauschale.BorderColor = 'unset';
                    _.find(vm.selectedMembershipPauschalenToSelect, {'Id':pauschale.Id}).BorderColor = 'unset';
                }
            }
            if (vm.pflichtGebuehrenOrig.length > 0) {
                vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.pflichtGebuehrenOrig);
                vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
                    return element !== undefined;
                });
                vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
                _.forEach(vm.pflichtGebuehren, function (g) {
                    g.zahlzyklusName = g[0].zahlzyklus
                });
            } else {
                vm.pflichtGebuehren = _.concat(vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren);
                vm.pflichtGebuehren = vm.pflichtGebuehren.filter(element => {
                    return element !== undefined;
                });
                vm.pflichtGebuehren = _.groupBy(vm.pflichtGebuehren, 'zahlzyklus');
                _.forEach(vm.pflichtGebuehren, function (g) {
                    g.zahlzyklusName = g[0].zahlzyklus
                });
            }
        };

        function parseCycles(value, unit) {
            // if (!value || !unit)
            //     return "";

            if (value === 0)
                return $translate.instant("T_einmalig");

            return ((value > 1) ? value + "-" : "") + $translate.instant(cycleUnits[unit][2]);
        }

        vm.pauschalenZyklen = {};
        _.forEach(vm.selectedMembership.Prices.Pauschalenpreise, function (v, k) {
            let f = (_.find(vm.selectedAdditionsPauschalen, {'Id': k}));
            if (f) {
                vm.pauschalenZyklen[k] = parseCycles(f.Zyklus, f.Zykluseinheit);
            }
        });


        vm.showShopingCard = function () {
            if (vm.openShopingCart === false) {
                vm.openShopingCart = true;
            } else {
                vm.openShopingCart = false
            }
        }

        vm.openInfoTextExtraAddition = function (id) {
            event.stopPropagation();
            vm.selectedExtraAdditionsInfo.push(id);
            vm.infoTextExtraAddition = true;
            if (!_.includes(vm.selectedExtraAdditionsInfo, id)) {
                vm.selectedExtraAdditionsInfo.push(id);
            } else {
                _.pull(vm.selectedExtraAdditionsInfo, id);
            }
        };

        vm.closeInfoTextExtraAddition = function (id) {
            event.stopPropagation();
            _.pull(vm.selectedExtraAdditionsInfo, id);
            vm.infoTextExtraAddition = false;
            if (!_.includes(vm.selectedExtraAdditionsInfo, id)) {
                vm.selectedExtraAdditionsInfo.push(id);
            } else {
                _.pull(vm.selectedExtraAdditionsInfo, id);
            }
        };

        vm.openedDetails = [];
        vm.selectedOpenedDetails = [];

        vm.openAndCloseDetailsGebuehrenPauschalen = function (key) {
            vm.openedDetailsKey = key;
            if (!_.includes(vm.selectedOpenedDetails, key.zahlzyklusName)) {
                vm.selectedOpenedDetails.push(key.zahlzyklusName);
            } else {
                _.pull(vm.selectedOpenedDetails, key.zahlzyklusName);
            }
            if (vm.openedDetails[key.zahlzyklusName] === true) {
                vm.openedDetails[key.zahlzyklusName] = false;
            } else
                vm.openedDetails[key.zahlzyklusName] = true;
        };

        vm.moveLeftZL = function () {
            vm.chunkedZL = _.chunk(_.concat(vm.selectedMembershipAdds.Gebuehren, vm.selectedMembershipAdds.Pauschalen), vm.limitLengthZL);
            vm.lengthChunkedZL = (vm.chunkedZL).length;
            vm.beginZL--;
            if (vm.beginZL < 0) {
                vm.beginZL = vm.lengthChunkedZL;
            }
            vm.currentZL = vm.chunkedZL[vm.beginZL];
        };

        vm.moveRightZL = function () {
            vm.chunkedZL = _.chunk(_.concat(vm.selectedMembershipAdds.Gebuehren, vm.selectedMembershipAdds.Pauschalen), vm.limitLengthZL);
            vm.lengthChunkedZL = (vm.chunkedZL).length;
            vm.beginZL++;
            if (vm.beginZL === vm.lengthChunkedZL) {
                vm.beginZL = 0;
            }
            vm.currentZL = vm.chunkedZL[vm.beginZL];

        };


        vm.minZusatzleistungenNichtErreicht = function () {
            var minZL = vm.parent.minZusatzleistungen || 0;
            if (minZL <= 0) return false;
            var selected = (vm.selectedAdditions ? vm.selectedAdditions.length : 0)
                         + (vm.selectedAdditionsGebuehren ? vm.selectedAdditionsGebuehren.length : 0)
                         + (vm.selectedAdditionsPauschalen ? vm.selectedAdditionsPauschalen.length : 0)
                         + (vm.selectedPauschalenWithMembershipZyklus ? vm.selectedPauschalenWithMembershipZyklus.length : 0);
            return selected < minZL;
        };

        vm.buyMembership = function () {
            if (vm.minZusatzleistungenNichtErreicht()) return;
            vm.parent.buyMembership(vm.selectedMembership, vm.selectedMembership.MitgliedschaftsNr, vm.selectedMembership.Basistarif,
                vm.selectedMembership.Pflichtgebuehren, vm.selectedMembership.SelectedAdditions, vm.selectedMembership.SelectedPauschalen,
                vm.selectedMembership.SelectedGebuehren, vm.selectedAdditionsGesamt, vm.selectedFoundAngebot, vm.parent.choosenMemberAngebot,
                vm.parent.selectedAngebot, vm.choosenMemberAngebotDatum, vm.selectedFoundAngebotDatum, vm.choosenNewangebotForMember, vm.pflichtZusatztarife,
                vm.pflichtZusatztarifePreis, vm.selectedAdditions, vm.pflichtGebuehren, vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.selectedAdditionsIds,
                vm.selectedAdditionsGebuehrenIds, vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds);
        }

        vm.goToAdditions = function () {
            if(vm.parent.angebot) {
                return
            } else {
                if(vm.parent.hasZusatztarife===true && vm.parent.zusatztarifenWithPrice && vm.parent.zusatztarifenWithPrice['true']) {
                vm.parent.goToAdditions('additions');
                } else {
                    vm.parent.goToSurveys('surveys', false, false, false, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
                }
            }
        }

        vm.goBackOptions = function () {
           if(vm.parent.hasZusatztarife===true && vm.parent.zusatztarifenWithPrice['true']) {
                vm.parent.goToAdditionsAngebot('additions', vm.parent.memberSelected, vm.parent.selectedMember, vm.parent.hasZusatztarife, vm.selectedMembership.Zusatztarife_Step_Online,
                    vm.parent.choosenMemberAngebot, vm.parent.selectedFoundAngebot, vm.selectedAdditions, vm.selectedAdditionsGesamt,
                    vm.parent.selectedMembership, vm.selectedAdditionsGesamt, vm.pflichtZusatztarifePreis,vm.selectedAdditionsIds, vm.selectedAdditionsGebuehrenIds,
                    vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
            } else {
             //  if(!vm.choosenMemberAngebot && !vm.selectedFoundAngebot) {
                vm.parent.goToSurveysAngebot('surveys', vm.parent.memberSelected, vm.parent.selectedMember, vm.parent.choosenNewangebotForMember,
                    vm.parent.selectedMembership, vm.selectedMembershipAdds, vm.choosenMembershipIndex, vm.selectedAdditions, vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren,
                    vm.selectedAdditionsGesamt, vm.pflichtZusatztarifePreis, vm.selectedAdditionsIds, vm.selectedAdditionsGebuehrenIds,
                    vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
               //}
            }
        }
        vm.buyMembershipAngebot = function () {
            vm.selectedMembership.Zusatztarife = vm.selectedMembership.ZusatztarifeOrig;
            vm.selectedMembership.Gebuehren = vm.selectedMembership.GebuehrenOrig;
            vm.selectedMembership.Pauschalen = vm.selectedMembership.PauschalenOrig;
            vm.parent.buyMembership(vm.selectedMembership, vm.selectedMembership.MitgliedschaftsNr, vm.selectedMembership.Basistarif,
                vm.selectedMembership.Pflichtgebuehren, vm.selectedMembership.SelectedAdditions, vm.selectedMembership.SelectedPauschalen,
                vm.selectedMembership.SelectedGebuehren, vm.selectedAdditionsGesamt, vm.selectedFoundAngebot, vm.parent.choosenMemberAngebot,
                vm.parent.selectedAngebot, vm.choosenMemberAngebotDatum, vm.selectedFoundAngebotDatum, vm.choosenNewangebotForMember, vm.pflichtZusatztarife,
                vm.pflichtZusatztarifePreis, vm.selectedAdditions, vm.pflichtGebuehren, vm.selectedAdditionsPauschalen, vm.selectedAdditionsGebuehren, vm.selectedAdditionsIds,
                vm.selectedAdditionsGebuehrenIds, vm.selectedAdditionsPauschalenIds, vm.selectedPauschalenWithMembershipZyklus, vm.selectedPauschalenWithMembershipZyklusIds)
        }
    }]);